import Heading from 'components/Basic/Heading/Heading';
import Link from 'components/Basic/Link/Link';
import Button from 'components/Forms/Button/Button';
import styled, { css } from 'styled-components';

const localVariables = {
    registrationButtonOffset: '20px',
    loyaltyClubPaddingRight: '90px',
} as const;

export const LoyaltyClubStyled = styled.div`
    ${({ theme }) => css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px ${localVariables.loyaltyClubPaddingRight} 20px 20px;

        background-color: ${theme.color.grayLight};
        border-radius: 0 0 ${theme.radius.medium} ${theme.radius.medium};

        @media ${theme.mediaQueries.queryNotLargeDesktop} {
            padding: 20px;
        }

        @media ${theme.mediaQueries.queryTablet} {
            flex-direction: column;
        }
    `}
`;

export const LoyaltyClubLeftColumnStyled = styled.div`
    ${({ theme }) => css`
        display: flex;
        justify-content: start;
        align-items: center;
        column-gap: 40px;
        width: 45%;

        @media ${theme.mediaQueries.queryNotLargeDesktop} {
            column-gap: 20px;
        }

        @media ${theme.mediaQueries.queryTablet} {
            width: 100%;
            justify-content: start;
        }
    `}
`;

export const LoyaltyClubRightColumnStyled = styled.div`
    ${({ theme }) => css`
        width: 100%;

        @media ${theme.mediaQueries.queryLg} {
            width: 55%;
            min-width: 400px;
            display: flex;
            align-items: end;
            flex-direction: column;
        }
    `}
`;

export const HighButtonStyled = styled(Button)`
    min-height: 50px;
    height: min-content;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const LoyaltyClubSpinboxWrapperStyled = styled.div`
    ${({ theme }) => css`
        @media ${theme.mediaQueries.querySm} {
            max-width: 100%;
        }
    `}
`;

export const LoyaltyClubSigningButtonWrapperStyled = styled.div`
    ${({ theme }) => css`
        display: flex;
        justify-content: space-between;
        column-gap: 20px;
        margin-top: calc(${localVariables.registrationButtonOffset} + 12px);
        margin-bottom: 12px;

        @media ${theme.mediaQueries.queryTablet} {
            flex-direction: column;
            row-gap: 24px;
            align-items: center;
        }
    `}
`;

export const LoyaltyClubBenefitsStyled = styled.ul``;

export const LoyaltyClubBenefitStyled = styled.li`
    ${({ theme }) => css`
        line-height: 20px;
        margin: 10px 0;
        display: flex;

        color: ${theme.color.red};
        font-weight: 700;
    `}
`;

export const LoyaltyClubHeadingStyled = styled(Heading)`
    margin-bottom: 0;

    font-weight: 400;
`;

export const LoyaltyClubPointsInfoStyled = styled.span`
    ${({ theme }) => css`
        height: ${localVariables.registrationButtonOffset};

        color: ${theme.color.grayDark};
        font-size: ${theme.fontSize.extraSmall};
    `}
`;

export const SignUpWrapperStyled = styled.div`
    text-align: center;
`;

export const LoyaltyClubBenefitsLinkStyled = styled(Link)`
    ${({ theme }) => css`
        font-size: ${theme.fontSize.small};
        margin-top: 11px;

        @media ${theme.mediaQueries.queryTablet} {
            margin-top: 24px;
        }
    `}
`;

export const HighLinkStyled = styled(Link)`
    min-height: 50px;
    height: min-content;
    display: flex;
    justify-content: center;
    align-items: center;
`;
